import { COLORS } from '../utils/colors';
import { siteContent } from '../content';
import { StatCard, Section } from './Card';

export const Outcomes = ({ isVisible }) => (
  <Section
    id="outcomes"
    alt
    isVisible={isVisible}
    title={<>Outcomes <span style={{ color: COLORS.cantaloupe }}>Delivered</span></>}
    subtitle={siteContent.outcomes.subtitle}
  >
    <div className="grid md:grid-cols-4 gap-6">
      {siteContent.outcomes.metrics.map((outcome, index) => (
        <StatCard key={outcome.label} value={outcome.value} label={outcome.label} colorIndex={index} />
      ))}
    </div>
  </Section>
);
